import { Reveal, SectionHeader } from "./SectionHeader";

const STEPS = [
  {
    n: "1",
    title: "Nos cuentas",
    text: "Qué texto necesitas adaptar y para quién. Ley, sanidad, cultura, administración…",
  },
  {
    n: "2",
    title: "Lo adaptamos",
    text: "Escribimos la versión fácil siguiendo la norma UNE 153101, palabra por palabra.",
  },
  {
    n: "3",
    title: "Se valida",
    text: "El grupo del CAI de Pando lo revisa en mesa de trabajo y confirma que se entiende.",
  },
  {
    n: "4",
    title: "Te lo entregamos",
    text: "Con maquetación accesible, lista para imprimir o publicar en tu web.",
  },
];

export default function Process() {
  return (
    <section id="proceso" className="py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <SectionHeader
          eyebrow="Cómo trabajamos"
          title="Cuatro pasos. Cero barreras."
          text="Cada proyecto pasa por las mismas manos expertas, y siempre acaba en manos del grupo validador."
        />
        <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14" data-testid="process-list">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1} className="h-full">
              <li className="relative h-full sketch bg-[var(--card)] p-6 pt-8 flex flex-col gap-3 hover:-translate-y-1 transition-transform">
                <span className="absolute -top-5 left-6 inline-flex items-center justify-center w-11 h-11 sketch-sm bg-[var(--yellow)] font-display font-extrabold text-xl shadow-[3px_3px_0_var(--ink)]">
                  {s.n}
                </span>
                <h3 className="font-display font-bold text-xl mt-2">{s.title}</h3>
                <p className="text-base leading-relaxed text-[var(--muted)]">{s.text}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
